// Per-language invitation templates, shared by the two template editors.
//
// A template keeps English at the top level (subject/html/text) and other
// languages under `translations` -- see functions/invitation_language.js for
// how the sender picks one.
import { LOCALES } from './i18n.js';

export const EMPTY_TEMPLATE = { subject: '', html: '', text: '' };

// Languages an invitation can be written in: every known locale, enabled or
// not, so a translation can be prepared before the language is switched on.
export const templateLanguages = () => Object.keys(LOCALES);

export const hasContent = (t) => !!(t && (t.subject || t.html || t.text));

// The {subject, html, text} for one language, or null if there is none.
export const getTemplateLanguage = (template, lang) => {
  if (!template) return null;
  const source = lang === 'en' ? template : (template.translations || {})[lang];
  return hasContent(source)
    ? { subject: source.subject || '', html: source.html || '', text: source.text || '' }
    : null;
};

// Builds a template from {lang: {subject, html, text}}. Languages without
// content are left out; English stays at the top level.
export const buildTemplate = (byLanguage) => {
  const template = {};
  const en = byLanguage.en;
  if (hasContent(en)) Object.assign(template, { subject: en.subject, html: en.html, text: en.text });
  const translations = {};
  for (const [lang, data] of Object.entries(byLanguage)) {
    if (lang !== 'en' && hasContent(data)) translations[lang] = { subject: data.subject, html: data.html, text: data.text };
  }
  if (Object.keys(translations).length) template.translations = translations;
  return template;
};
